export var EncryptionServiceEvent;
(function (EncryptionServiceEvent) {
    EncryptionServiceEvent["RootKeyStatusChanged"] = "RootKeyStatusChanged";
})(EncryptionServiceEvent || (EncryptionServiceEvent = {}));
